import * as Yup from "yup";
import { StringValidation, DropdownValidation } from "../PlanSchema";

export const KPISchema = Yup.object().shape({
  name: StringValidation.label("KPI name"),
  score_type: DropdownValidation.label("Data Type"),
  kpi_type: DropdownValidation.label("KPI Type"),
  optimisation: DropdownValidation.label("Optimisation"),
});

export const KPI360Schema = Yup.object().shape({
  name: StringValidation.label("KPI name"),
});
